import React from "react";
import ReactDOM from "react-dom/client";
import { lazy, Suspense } from "react";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Keep the legacy role router and its Bootstrap styles out of the worker bundle.
const App = lazy(() =>
  process.env.REACT_APP_ADMIN_ONLY === "true"
    ? import("./admin/AdminApp")
    : process.env.REACT_APP_WORKER_ONLY === "true"
      ? import("./worker/WorkerApp")
      : import("./App"),
);
root.render(
  <Suspense
    fallback={
      <div role="status" style={{ padding: 32 }}>
        Загрузка кабинета…
      </div>
    }
  >
    <App />
  </Suspense>,
);
reportWebVitals();
